import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import addYears from 'date-fns/add_years';
import subYears from 'date-fns/sub_years';
import addMonths from 'date-fns/add_months';
import subMonths from 'date-fns/sub_months';
import isBefore from 'date-fns/is_before';
import isAfter from 'date-fns/is_after';
import isSameMonth from 'date-fns/is_same_month';
import isSameYear from 'date-fns/is_same_year';
import { CalendarMonthView } from "./components/MonthView";
import { CalendarHeader } from "./components/Header";
import { getMonthAlias, weekDays } from "./utils/utils";
import cx from "./utils/styles";
var Calendar = /*#__PURE__*/function (_PureComponent) {
  _inherits(Calendar, _PureComponent);
  var _super = _createSuper(Calendar);
  function Calendar(props) {
    var _this;
    _classCallCheck(this, Calendar);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "isAllowedPrevMonth", function () {
      var min = _this.props.min;
      var prevMonth = subMonths(_this.state.viewDate, 1);
      return !min || isSameMonth(prevMonth, min) || isAfter(prevMonth, min);
    });
    _defineProperty(_assertThisInitialized(_this), "isAllowedNextMonth", function () {
      var max = _this.props.max;
      var nextYear = addMonths(_this.state.viewDate, 1);
      return !max || isSameMonth(nextYear, max) || isBefore(nextYear, max);
    });
    _defineProperty(_assertThisInitialized(_this), "isAllowedPrevYear", function () {
      var min = _this.props.min;
      var prevYear = subYears(_this.state.viewDate, 1);
      return !min || isSameYear(prevYear, min) || isAfter(prevYear, min);
    });
    _defineProperty(_assertThisInitialized(_this), "isAllowedNextYear", function () {
      var max = _this.props.max;
      var nextYear = addYears(_this.state.viewDate, 1);
      return !max || isSameYear(nextYear, max) || isBefore(nextYear, max);
    });
    _defineProperty(_assertThisInitialized(_this), "isHideTodayButton", function () {
      var min = _this.props.min;
      return !!min && min > Date.now();
    });
    _defineProperty(_assertThisInitialized(_this), "handlePrevMonthSelect", function () {
      return _this.setState({
        viewDate: subMonths(_this.state.viewDate, 1)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleNextMonthSelect", function () {
      return _this.setState({
        viewDate: addMonths(_this.state.viewDate, 1)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handlePrevYearSelect", function () {
      return _this.setState({
        viewDate: subYears(_this.state.viewDate, 1)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleNextYearSelect", function () {
      return _this.setState({
        viewDate: addYears(_this.state.viewDate, 1)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDayClick", function (date) {
      _this.setState({
        viewDate: date
      });
      _this.props.onChange(date);
    });
    _this.state = {
      viewDate: props.value
    };
    return _this;
  }
  _createClass(Calendar, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var className = this.props.className;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('wrapper', className),
        "data-t-id": "components-Calendar"
      }, /*#__PURE__*/React.createElement(CalendarHeader, {
        isNextAllowed: this.isAllowedNextYear(),
        isPrevAllowed: this.isAllowedPrevYear(),
        onNextClick: this.handleNextYearSelect,
        onPrevClick: this.handlePrevYearSelect
      }, this.state.viewDate.getFullYear()), /*#__PURE__*/React.createElement(CalendarHeader, {
        isNextAllowed: this.isAllowedNextMonth(),
        isPrevAllowed: this.isAllowedPrevMonth(),
        onNextClick: this.handleNextMonthSelect,
        onPrevClick: this.handlePrevMonthSelect
      }, getMonthAlias(this.state.viewDate.getMonth())), /*#__PURE__*/React.createElement("div", {
        className: cx('daysOfWeek')
      }, weekDays.map(function (alias) {
        return /*#__PURE__*/React.createElement("div", {
          className: cx('dayOfWeek'),
          key: "wday-alias:".concat(alias)
        }, alias);
      })), /*#__PURE__*/React.createElement(CalendarMonthView, {
        max: this.props.max,
        min: this.props.min,
        month: this.state.viewDate,
        onDayClick: this.handleDayClick,
        selectedDay: this.props.value
      }), !this.isHideTodayButton() && /*#__PURE__*/React.createElement("button", {
        className: cx('today'),
        onClick: function onClick() {
          return _this2.handleDayClick(new Date());
        },
        type: "button"
      }, "\u0441\u0435\u0433\u043E\u0434\u043D\u044F"));
    }
  }]);
  return Calendar;
}(PureComponent);
_defineProperty(Calendar, "defaultProps", {
  value: new Date(),
  min: undefined,
  max: undefined
});
export { Calendar as default };
Calendar.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
} : {};